// extracted by mini-css-extract-plugin
export default {"footerCancelButton":"-BVcW","iconButton":"_2Qa8t","iconSuccess":"_2cHpD","success-icon":"_1O4aK","footerEnterButton":"PCJgZ"};